var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"cd-box-component cd-box-color",attrs:{"img-src":_vm.finalImage}},[_c('b-card-text',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }